import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ajax from "@/libs/injectAjax";
import {  Overlay, Toast, Progress, Stepper, Popup, Picker, Dialog } from 'vant';
import '@/libs/sensors';
Vue.config.productionTip = false;
Vue.use(v => Object.assign(v.prototype, ajax))
  .use(Overlay)
  .use(Progress)
  .use(Stepper)
  .use(Popup)
  .use(Picker)
  .use(Dialog)
  .use(Toast);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
